import { BaseModel } from "../../core/src/model/BaseModel";

class VendorModel extends BaseModel<IVendorData> {
    public freeGames:IFreeGamesData = null;
    protected _inFreeGames = false;
    public hasFreeGamesExpired = false;

    public get inFreeGames():boolean {
        return this._inFreeGames;
    }

    public enterFreeGames(){
        this._inFreeGames = true;
    }

    public exitFreeGames(){
        this._inFreeGames = false;
        this.freeGames = null;
        this.hasFreeGamesExpired = false;
    }

}

export default new VendorModel();

export interface IVendorData {
    freeGames:IFreeGamesData;
}

export interface IFreeGamesData extends IFreeGamesBetOption {
    type:string,
    win:number,
    spinsended:boolean,
    perSpinPayouts?:boolean,
    featureTrigger?:boolean,
    spinsPlayed?: number,
    autoplay:boolean,
    expires:number,
    betSizeOptions?:IFreeGamesBetOption[]
}

export interface IFreeGamesBetOption {
    spins:number,
    ba:number
}
// autoplay: true
// ba: 50
// expires: 1596465720
// perSpinPayouts: false
// spins: 4
// spinsPlayed: 6
// spinsended: false
// type: "money"
// win: 125
